import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/api';
import { useLanguage } from '../../contexts/LanguageContext';
import './MyOrders.css'; // We will create this next

const MyOrders = () => {
  const { t, language } = useLanguage();
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await apiService.getMyOrders();
        if (response.success) {
          setOrders(response.data);
        } else {
          throw new Error(response.message || t('dashboard.orders.errors.fetchFailed'));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const locale = language === 'hi' ? 'hi-IN' : language === 'or' ? 'or-IN' : 'en-IN';

  const formatPrice = (price) => {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'INR' }).format(price);
  };
  const getTranslatedStatus = (status) => {
    const normalized = String(status || '').toLowerCase();
    const translated = t(`dashboard.common.status.${normalized}`, {}, '');
    if (translated) return translated;
    return status;
  };

  if (isLoading) return <div className="loading-spinner">{t('dashboard.orders.loading')}</div>;

  if (error) {
    return <div className="error-message">{t('dashboard.common.errorPrefix')}: {error}</div>;
  }

  return (
    <div className="my-orders-container">
      <h2>{t('dashboard.sidebar.myStoreOrders')}</h2>
      {orders.length === 0 ? (
        <div className="no-orders">
          <p>{t('dashboard.orders.emptyMessage')}</p>
          <Link to="/bhakti-store" className="btn btn-primary">{t('dashboard.orders.shopNow')}</Link>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map((order) => (
            <div key={order._id} className="order-card">
              <div className="order-card-header">
                <div>
                  <h4>{t('dashboard.orders.orderLabel')} #{order._id.substring(0, 8)}...</h4>
                  <p>{t('dashboard.orders.placedOn')}: {new Date(order.createdAt).toLocaleDateString(locale)}</p>
                </div>
                <span className={`status-badge status-${order.orderStatus.toLowerCase()}`}>
                  {getTranslatedStatus(order.orderStatus)}
                </span>
              </div>
              <div className="order-card-body">
                {order.orderItems.map(item => (
                  <div key={item.product} className="order-item">
                    <img src={item.image} alt={item.name} className="item-image" />
                    <div className="item-details">
                      <p className="item-name">{item.name}</p>
                      <p className="item-qty">{t('dashboard.orders.quantity')}: {item.quantity}</p>
                    </div>
                    <p className="item-price">{formatPrice(item.price * item.quantity)}</p>
                  </div>
                ))}
              </div>
              <div className="order-card-footer">
                <strong>{t('dashboard.orders.total')}: {formatPrice(order.totalAmount)}</strong>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyOrders;
